import comp from "./MultiSelectWithImage";
export default comp;
